import React, { useState, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import { useDispatch, useSelector } from "react-redux";
import { getJackpotNumberData } from "../../redux/slices/winnersSlice";

const WheelSpinner = () => {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const { jackpotNumber } = useSelector((state) => state.winners);
  const lotteryNumber = jackpotNumber?.number;
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch jackpot data if lotteryNumber is defined and not null
    if (lotteryNumber !== null && lotteryNumber !== undefined) {
      dispatch(getJackpotNumberData());
    }
  }, [dispatch, lotteryNumber]);

  // Data with numbers 0-9 for prize options and unique rich colors
  const data = [
    {
      option: "0",
      style: { backgroundColor: "#9b59b6", textColor: "#ffffff" },
    }, // Purple
    {
      option: "1",
      style: { backgroundColor: "#f39c12", textColor: "#ffffff" },
    }, // Gold
    {
      option: "2",
      style: { backgroundColor: "#e74c3c", textColor: "#ffffff" },
    }, // Red
    {
      option: "3",
      style: { backgroundColor: "#2ecc71", textColor: "#ffffff" },
    }, // Green
    {
      option: "4",
      style: { backgroundColor: "#16a085", textColor: "#ffffff" },
    }, // Teal
    {
      option: "5",
      style: { backgroundColor: "#2980b9", textColor: "#ffffff" },
    }, // Blue
    {
      option: "6",
      style: { backgroundColor: "#f1c40f", textColor: "#ffffff" },
    }, // Yellow
    {
      option: "7",
      style: { backgroundColor: "#e67e22", textColor: "#ffffff" },
    }, // Orange
    {
      option: "8",
      style: { backgroundColor: "#34495e", textColor: "#ffffff" },
    }, // Dark Gray
    {
      option: "9",
      style: { backgroundColor: "#1abc9c", textColor: "#ffffff" },
    }, // Light Green
  ];

  // Automatically spin the wheel when the component is mounted
  useEffect(() => {
    if (lotteryNumber !== null && lotteryNumber !== undefined) {
      setPrizeNumber(lotteryNumber); // Set prize number to lottery number if available
      setMustSpin(true);
    }
  }, [lotteryNumber]);

  const handleSpinClick = () => {
    if (!mustSpin) {
      const newPrizeNumber = 9; // Random number on button click
      setPrizeNumber(newPrizeNumber);
      setMustSpin(true);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="relative flex items-center justify-center bg-gradient-to-r from-yellow-400 to-orange-500 p-1 rounded-full shadow-2xl">
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={data}
          backgroundColors={data.map((item) => item.style.backgroundColor)}
          textColors={data.map((item) => item.style.textColor)}
          onStopSpinning={() => setMustSpin(false)}
          spinDuration={2}
          outerBorderColor="#000"
          outerBorderWidth={6}
          innerRadius={60}
          radiusLineColor="#000"
          radiusLineWidth={8}
          fontSize={24}
          perpendicularText
          textDistance={35}
        />
        {/* Spinner Center Circle */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-black rounded-full w-14 h-14"></div>
      </div>

      {/* <button
        onClick={handleSpinClick}
        className="mt-8 bg-gradient-to-r from-yellow-400 to-orange-500 text-white py-4 px-10 text-xl rounded-lg shadow-lg transform transition duration-300 hover:bg-gradient-to-r hover:from-yellow-500 hover:to-red-600 hover:scale-105"
      >
        Spin the Wheel
      </button> */}
    </div>
  );
};

export default WheelSpinner;
